/**
 * Text Formatting Utilities
 * Contains helper functions for formatting and transforming text content
 */

/**
 * Converts ® symbol to superscript format
 * @param text - The text containing ® symbols
 * @returns React elements with ® in superscript
 *
 * @example
 * formatRegisteredSymbol("Member Loyalty® Accident Insurance")
 * // Returns: "Member Loyalty<sup>®</sup> Accident Insurance"
 */
export const formatRegisteredSymbol = (text: string) => {
    return text.split("®").map((part, index, array) => (
        <span key={index}>
            {part}
            {index < array.length - 1 && <sup>®</sup>}
        </span>
    ));
};
